import $ from "jquery";
import deferAction from "scripts/utils/deferAction";
import modalCart from "./modals/modalCart";
import modalPreview from "./modals/modalPreview";
import modalSearch from "./modals/modalSearch";
import modalCredits from "./modals/modalCredits";
import modalLogin from "./modals/modalLogin";

import { GAViewCart } from "./ga/view_cart";
import eSputnik from "./eSputnik";
import { GUID } from "../utils";
import tooltip from "./tooltip";

const callModal = {
  "modal-cart": ([newProduct, open]) => modalCart.call(newProduct, open),
  "modal-preview": (src) => modalPreview.call(src),
  "modal-search": () => modalSearch.call(),
  "modal-credit": (productId) => modalCredits.call(productId),
  "modal-login": (source) => modalLogin.call(source),
};

const openLoginIfUrl = () => {
  const { location } = window;

  if (location.hash === "#modal-login") {
    const getLocation = location.href.replace("#modal-login", "");
    modalLogin.call();
    window.history.pushState("", "", `${getLocation}`);
  }
};

const modals = () => {
  let productPageSrc = "";

  if ($(".block-product .large-image__item img").length) {
    productPageSrc = $(".block-product .large-image__item img").attr("src");
  }

  const documentHandler = (event) => {
    if (event.keyCode === 27) {
      close();
    }
  };

  const close = () => {
    $(".modal").fadeOut(300);
    // Dispatch event to close modal
    const event = new CustomEvent("closeModal", {
      bubbles: true,
      cancelable: true,
      detail: {
        target: $(".modal").attr("data-target"),
      },
    });
    document.dispatchEvent(event)
    
    $("html").removeClass("overflow");
    $(".gift-form").removeClass("active");
    document.removeEventListener("click", documentHandler, false);
    setTimeout(() => {
      document.querySelector("body > .modal")?.remove();
    }, 300);
  };

  const open = (target, src, targetAttr) => {
    if (target.length) {
      $(".modal").fadeOut(300);
      $("html").addClass("overflow");
      const isCheckoutPage = $(".checkout-fields").length;

      if (src) {
        target.find(".js-preview-image").attr("src", src);
      } else if (targetAttr === "modal-cart" && !target.hasClass("active")) {
        callModal[targetAttr]([false, true])
      }
      target.fadeIn(300);
      if (targetAttr === "modal-search") {
        $("#modal-search-input").focus();
      } else if (targetAttr === "modal-login") {
        $("#modal-login-tel").focus();
      }
      document.addEventListener("keyup", documentHandler, false);
    }
  };

  $(document)
    .on("click", ".modal-btn", function openModal(e) {
      e.preventDefault();

      const $this = $(this);
      const target = $this.attr("data-target");
      const targetModal = $(`.modal[data-target='${target}']`);
      let src = "";
      let params = "";

      if (target === "modal-preview") {
        src = $this.attr("data-large");
        params = $this.attr("data-large");
      } else if (target === "modal-cart") {
        params = [false, true];
      } else if (target === "modal-gift") {
        params = productPageSrc;
      } else if (target === "modal-credit") {
        params = $(".block-product").data("id");
      } else if (target === "modal-login") {
        params = $this.attr("data-ga");
      }

      deferAction(() => {
        if (!targetModal.length || target === "modal-credit") {
          callModal[target](params);
        } else {
          open(targetModal, src, target);
        }
      });
    })
    .on("click", ".modal", (event) => {
      const { target } = event;

      if (
        !$(target).closest(
          ".modal-content, .js_favorite_modal_content, .js_city_modal"
        ).length ||
        $(target).hasClass("js-close") ||
        $(target).closest(".js-close").length
      ) {
        deferAction(() => {
          close();
        });
      }
    });
};

openLoginIfUrl();
tooltip();

export default modals;
